export default {
	sectionTitle: {
		 en: 'Meet our speakers',
	},
	paragraph: {
		en: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In blandit erat neque, a imperdiet justo fermentum nec. Proin aliquam elementum ligula ac tristique.',
	}
};
